import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
render(<App data-id="element-226" />, document.getElementById('root'));
// Preconnect to CDN for LCP image (only critical preconnect)
if (typeof window !== 'undefined') {
  const pc = document.createElement('link');
  pc.rel = 'preconnect';
  pc.href = 'https://cdn.magicpatterns.com';
  document.head.appendChild(pc);
}
// Defer Meta Pixel — load 3s after page load to not block anything
if (typeof window !== 'undefined') {
  window.addEventListener('load', () => {
    setTimeout(() => {
      ;
      (function (f: any, b: any, e: any, v: string) {
        if (f.fbq) return;
        const n: any = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = '2.0';
        n.queue = [];
        const t = b.createElement(e) as HTMLScriptElement;
        t.async = true;
        t.src = v;
        b.head.appendChild(t);
      })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
      (window as any).fbq('init', '1688179945683486');
      (window as any).fbq('track', 'PageView');
    }, 3000);
  });
}